<template>
    <Card class="study-item">
      <p slot="title">
        <Icon :type="icon" :color="color"/>
          {{ model.abbreviation }}
      </p>
      <span slot="extra" @click="edit">
        <Icon type="ios-create" color="gray"></Icon>
      </span>
      <router-link :to="'/study/' + model.id">
        <Row>
          <Col span="8" class="study-item-logo">
            <img :src="model.logoLink"  alt="" v-if="model.logoLink">
            <img src="@/assets/images/no-logo.jpg" alt="" v-if="!model.logoLink">
          </Col>
          <Col span="16">
            <div class="">
              {{ model.code }}
            </div>
            <div class="">
              {{ model.phaseText }}
            </div>
            <div class="">
              <strong>开始日期</strong> {{ model.startdat }}
            </div>
          </Col>
        </Row>
      </router-link>
    </Card>
</template>

<script>
export default {
  name: 'study-item',
  data: function () {
    return {
      sts: {
        '1': {
          color: '#808695',
          icon: 'ios-square'
        },
        '2': {
          color: '#2d8cf0',
          icon: 'ios-loading'
        },
        '3': {
          color: '#ff9900',
          icon: 'ios-pause'
        },
        '4': {
          color: '#19be6b',
          icon: 'ios-checkbox'
        },
        '5': {
          color: '#8B5A00',
          icon: 'ios-archive'
        }
      }
    }
  },
  computed: {
    icon: function () {
      return this.sts[this.model.status].icon
    },
    color: function () {
      return this.sts[this.model.status].color
    }
  },
  props: ['model'],
  methods: {
    edit: function () {
      this.axios.post('/study/stick?id=' + this.model.id)
        .then((response) => {
          this.$emit('refresh')
        })
    }
  }
}
</script>

<style>
.study-item > a {
  background-color: #d7de51;
}
.study-item-actions {
  margin-top: 5px;
  text-align: center;
}
.study-item-logo > img{
  max-width: 72px;
}
</style>
